import * as React from "react";
import { FunctionComponent } from "react";
import ExportButtonSvg from "Graphics/Icons/ExportButtonSvg.svg";

const ExportIcon: FunctionComponent = () => <ExportButtonSvg style={{ width: 24, height: 24, fill: "rgb(117, 117, 117)" }} />;

export default ExportIcon;
